module.exports = __webpack_public_path__ + "assets/events_political_terrorism_white.a3d088e0.svg";